import { render, staticRenderFns } from "./BtnCancelar.vue?vue&type=template&id=7b3412c6"
import script from "./BtnCancelar.vue?vue&type=script&lang=js"
export * from "./BtnCancelar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports